import { Record, List } from 'immutable';
import PhotoHash from './PhotoHash';
import Collection from './Collection';
import InventoryRecord from './InventoryRecord';

const FeedItemDefaults = {
  type: null,
  object: null
};

class TextFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    super(values);
  }
}

class PhotoFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.photo_hash = new PhotoHash(values.object.photo_hash);

    super(values);
  }
}

class CarouselPhotoFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.photo_hash = new PhotoHash(values.object.photo_hash);
    values.object.collection = new Collection({
      title: values.object.text,
      description: values.object.description,
      slug: values.object.deeplink.replace(/^\//, ''),
      cover_photo_hash: values.object.photo_hash
    });

    super(values);
  }
}

class CarouselFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.items = (new List(values.object.items)).map((item) => {
      return new CarouselPhotoFeedItem(item);
    });

    super(values);
  }
}

class LinkListFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.items = (new List(values.object.items));

    super(values);
  }
}

class ProductFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.inventory_record = new InventoryRecord(values.object.inventory_record);

    super(values);
  }
}

class ProductGroupFeedItem extends Record(FeedItemDefaults) {
  constructor(values) {
    values.object.inventory_records = (new List(values.object.inventory_records)).map((inventoryRecord) => {return (inventoryRecord instanceof InventoryRecord ? inventoryRecord : new InventoryRecord(inventoryRecord));});

    super(values);
  }
}

class FeedItemFactory {
  static create(values) {
    console.log(values);
    switch(values.type) {
      case 'text':
        return new TextFeedItem(values);
      case 'photo':
        return new PhotoFeedItem(values);
      case 'carousel':
        return new CarouselFeedItem(values);
      case 'link_list':
        return new LinkListFeedItem(values);
      case 'product':
        return new ProductFeedItem(values);
      case 'product_group':
        return new ProductGroupFeedItem(values);
    }
  }
}

const StoreFeedDefaults = {
  items: new List()
};

class StoreFeed extends Record(StoreFeedDefaults) {
  constructor(values) {
    values.items = (new List(values.items)).map((item) => {return FeedItemFactory.create(item);});

    super(values);
  }
}

export default StoreFeed;



// WEBPACK FOOTER //
// banquet/models/StoreFeed.js